export default "__VITE_ASSET__BEEeh8XE__"